import { termsCoEfficientTable } from "../../constants";

export const AI_IMPORT_SOURCE = "AI_IMPORT";
export const AI_IMPORT_VERSION = "1.0";

export const ALLOWED_OPERATIONS = ["Loading", "Discharging"];
export const ALLOWED_FREIGHT_MODES = ["Single Freight", "Multiple Freight"];
export const ALLOWED_QTY_MODES = ["MOLOO", "MINMAX"];
export const ALLOWED_TERMS = termsCoEfficientTable.map((t) => t.label);

// CSV layout: one row per port operation. Cargo-level columns are filled on the first row only.
export const CARGO_CSV_COLUMNS = [
  ["name", "Text (e.g. Wheat Cargo Q1) - first row only"],
  ["freightMode", `One of: ${ALLOWED_FREIGHT_MODES.join(" | ")} - first row only`],
  ["qtyMode", `One of: ${ALLOWED_QTY_MODES.join(" | ")} - first row only`],
  ["laycanStartDate", "YYYY-MM-DD or ISO 8601 - first row only"],
  ["laycanEndDate", "YYYY-MM-DD or ISO 8601 - first row only"],
  ["suez", "true or false - first row only"],
  ["panama", "true or false - first row only"],
  ["message", "Text (Remarks / Notes) - first row only"],
  ["operation", `One of: ${ALLOWED_OPERATIONS.join(" | ")}`],
  ["port", "Text (port name)"],
  ["cargoQty", "Number (use if qtyMode is MOLOO)"],
  ["tolerance", "Number, % (use if qtyMode is MOLOO)"],
  ["min", "Number (use if qtyMode is MINMAX)"],
  ["max", "Number (use if qtyMode is MINMAX)"],
  ["rate", "Number (MT/Day)"],
  ["terms", `One of: ${ALLOWED_TERMS.join(" | ")}`],
  ["turnTime", "Number (Days)"],
  ["freight", "Number"],
  ["adcom", "Number, %"],
  ["other", "Number, %"],
  ["brokerage", "Number, %"],
  ["account", "Text (Counter party)"],
  ["cargo", "Text (Cargo Name)"],
  ["stowFactor", "Number"],
];
